<template>
  <v-toolbar color="primary" fixed dark app>
    <v-toolbar-title>
      <v-toolbar-side-icon @click="handleDrawerToggle"></v-toolbar-side-icon>
    </v-toolbar-title>
    <a href="#" @click="refresh()">
      <img class="ml-3" :src="computeLogo" height="46" alt="TSB Living Kiosk" />
    </a>
    <v-spacer></v-spacer>
    <v-btn color="accent" class="mr-5" large v-show="showStartOver" @click="startOver()">Start over</v-btn>
    <v-spacer></v-spacer>
    <v-toolbar-items>
      <span class="title mt-4 mr-3 unselectable">{{ clock }}</span>
      <v-menu offset-y origin="center center" :nudge-bottom="10" transition="scale-transition">
        <v-btn icon large flat slot="activator">
          <v-icon medium>fa-user</v-icon>
        </v-btn>
        <v-list class="pa-0">
          <v-list-tile
            v-for="(item, index) in items"
            :to="!item.href ? { name: item.name } : null"
            :href="item.href"
            @click="item.click"
            ripple="ripple"
            :disabled="item.disabled"
            :target="item.target"
            rel="noopener"
            :key="index"
          >
            <v-list-tile-action v-if="item.icon">
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>{{ item.title }}</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
      </v-menu>
    </v-toolbar-items>
  </v-toolbar>
</template>
<script>


export default {
  name: 'AppToolbar',
  components: {},
  data() {
    return {
      items: [
        {
          icon: 'account_circle',
          href: '#',
          title: this.$t('toobar.profile'),
          click: this.handleProfile,
        },
        {
          icon: 'settings',
          href: '#',
          title: this.$t('toobar.settings'),
          click: this.handleTheme,
        },
        {
          icon: 'logout',
          href: '#',
          title: this.$t('toobar.logout'),
          click: this.handleLogut,
        },
      ],
    }
  },
  computed: {
    toolbarColor() {
      return this.$vuetify.options.extra.mainNav
    },
    isMobile() {
      return this.$vuetify.breakpoint.xs
    },
    clock() {
      return this.$store.getters['time/currentTime'].format('H:mm:ss A')
    },
    computeLogo() {
      return '/static/logo_large_white.png'
    },
    showStartOver() {
      return this.$route.name !== 'Start' && this.$route.name !== 'Settings'
    },
  },
  methods: {
    handleDrawerToggle() {
      this.$emit('side-icon-click')
    },
    handleLogut() {
      this.$store.dispatch('users/logoutUser', {
        callback: () => {
          this.$router.push('/auth/login')
        },
      })
    },
    handleTheme() {
      this.$store.dispatch('showThemeSidebar', true)
    },
    handleProfile() {},
    startOver() {
      this.$router.push('/start')
    },
    refresh() {
      window.location.reload()
    },
  },
}
</script>

<style lang="stylus" scoped>

.unselectable {
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
}
</style>
